import { GridColDef, GridColumns } from '@mui/x-data-grid-premium';
import { useTranslation } from 'react-i18next';
import { baseCell } from '../cells/base-cell';

export function VersionColumns(): GridColDef[] {
  const { t } = useTranslation();
  const columns: GridColumns = [
    {
      field: 'field',
      headerName: t(`global.field`),
      minWidth: 220,
      flex: 1,
      renderCell: baseCell
    },
    {
      field: 'oldValue',
      headerName: t(`global.old-value`),
      minWidth: 300,
      flex: 2,
      sortable: false,
      renderCell: baseCell
    },
    {
      field: 'newValue',
      headerName: t(`global.new-value`),
      minWidth: 300,
      flex: 2,
      sortable: false,
      renderCell: baseCell
    }
  ];
  return columns;
}
